import VideoExternalPicker from './VideoExternalPicker';

export default VideoExternalPicker;
